module.exports = __webpack_public_path__ + "static/media/Zunavish_Logo_SVG.1951b622.svg";